import React from "react";
import { theme, styledSystem as ss } from "./support";

// Add global styles
const GlobalStyle = ss.createGlobalStyle<ss.ICommonProps & ss.IFontSizeProps & ss.ITypographyProps & { theme?: any }>`
	* { box-sizing: border-box; }
	body {
		margin: 0;
		${ss.COMMON}
		${ss.FONTSIZE}
		${ss.TYPOGRAPHY}
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	table { border-collapse: collapse; }
	.ficon { height: 24px; display: inline-block; vertical-align: text-bottom; }
	.ficon-sm { height: 16px !important; }
	.ficon-md { height: 32px !important; }
	.ficon-lg { height: 42px !important; }
	.ficon-fs { height: 1em; vertical-align: middle!important; }
`;
GlobalStyle.defaultProps = {
	theme,
	fontSize: "normal",
	lineHeight: "default",
	fontWeight: "normal",
	fontFamily: "normal",
	color: "text",
	bg: "body",
	m: 0,
	p: 0,
}

// Create the base styles wrapper
export function BaseStyles(props: any) {
	return (
		<>
			<GlobalStyle />
			{props.children}
		</>
	);
};
